<div
  class="trend-article-card"
  [class]="displayStyle"
  (click)="redirectToArticle(url)">
  <div
    class="trend-article-card__background-image"
    [appLazyLoad]="backgroundImage" [isBackground]="true"></div>
  <div class="trend-article-card__header">
    <h3 class="trend-article-card__title heading-xs">{{ title }}</h3>
    <span class="trend-article-card__abstract body-s">{{ abstract }}</span>
  </div>
</div>
